import { BaseService } from './base.service';
import { Observable, throwError as observableThrowError, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, catchError, publishReplay, refCount, switchMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { IPlayedTicketTO, IPlayedTicketWithGroupsTO } from 'src/app/models/ticket/transportObjects/playedTicketTO.interface';
import { IUpdateTicketRequestObjTO } from 'src/app/models/ticket/transportObjects/ubdateTicketRequestObjTO.interface';
import { IBetOutcomeWithPlayableStatusTO } from 'src/app/models/ticket/transportObjects/outcomeWithPlayableStatusTO.interface';
import { IAuthPlayer } from 'src/app/models/user/authPlayer.interface';
import { ITicketValidationRequestTO } from 'src/app/models/ticket-validation/transportObjects/ticketValidationRequestTO.interface';
import { ITicketValidationResultTO } from 'src/app/models/ticket-validation/transportObjects/ticketValidationResultTO.interface';
import { ITicketConfirmationRequestTO } from 'src/app/models/ticket/transportObjects/ticketConfirmationRequest.interface';
import { StorageService } from '../util/storage.service';
import { LoaderService } from '../loader.service';
import { UserActivityService } from '../userActivity.service';
import { NotificationService } from '../notification.service';
import { IJTBetPoint } from 'src/app/models/jacktime/betPoint.interface.ts';
import { IJTBetPointTO } from 'src/app/models/jacktime/transportObjects/betPointTO.interface.ts';
import { ISellBetRequest } from 'src/app/models/jacktime/transportObjects/sellBetRequestTO.interface';
import { DeployParams } from 'src/app/deployParams';
import { ITicketTO } from 'src/app/models/ticket/transportObjects/ticketTO.interface';
import { ICashOutValueResponseTO } from 'src/app/models/cashout/cashOutValueResponse.interface';
import { ISellBetRequestTm } from 'src/app/models/jacktime/transportObjects/sellBetRequestTmTO.interface';
import { ISellBetResponseTmTO } from 'src/app/models/ticket-validation/transportObjects/sellBetResponseTmTO.interface';
import { ISellBetResponse } from 'src/app/models/ticket-validation/sellBetResponse.interface';
import { ISellBetResponseTO } from 'src/app/models/ticket-validation/transportObjects/sellBetResponseTO.interface';
import { IExpressTicketTO } from 'src/app/models/ticket/transportObjects/expressTicketTO.interface';
import { environment } from 'src/environments/environment';

const ticketMoibile = {ticketId: 15394, ticketNumber: '120010002743', createdOn: '2021-01-28T13:45:50.4570000Z', quota: 2.5500, numberOfMatches: 6, numberOfCombinations: 4, type: 'Prematch', system: 'Fix 3, System 2,3/3 - 4 Bets', stake: 9.5000, possibleMaxWin: 24.2300, possibleMinWin: 0, status: {name: 'Paid', code: 8}, bonus: 0.0000, jackTimeId: 0, casheback: null, blockedForSell: null, roundedCasheback: null, dividedTicketsCount: 1, ticketItems: [{code: '3854', name: 'Oostende - Standard Liege', eventId: 120186, competition: '1. liga', region: 'Belgija', sport: 'NOGOMET', betTypeName: '1X2', betTypeOutcomeName: '1', sBV: '', odd: 2.55, time: '2021-01-28T20:00:00Z', result: '1:0(1:0)', system: 'F', status: {name: '6', code: 6}, betTypeId: 135, betTypeOutcomeId: 424, competitionId: 17566, regionId: 1079, sportId: 1, betId: 10893345, betOutcomeId: 41088035, isLive: 0, id: 68548, listScore: ['1', ':', '0', null, '(1', ':0)', null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null], betTypeValueType: 0, eventMappingType: 1}], minOdd: 2.5500, payin: 10.0000, taxBeforeStake: 0.5000, possiblePayout: 22.7600, possibleMinPayout: 0, taxOnWinning: 1.4700, taxOnMinWinning: 0};
@Injectable()
export class TicketProviderService extends BaseService {
  private language: string;
  constructor(private http: HttpClient,
              private storage: StorageService,
              protected loaderService: LoaderService,
              protected userActivityService: UserActivityService,
              protected notificationService: NotificationService) {
    super(loaderService, userActivityService, notificationService, storage);
    this.language = storage.language;
  }

  // getLastFiveTickets(userId: number, status: number): Observable<IPlayedTicketTO[]> {
  //   const url: string = this.baseUrlWebClient + 'getLastFiveTickets/' + userId + '?status=' + status;
  //   // const headers = new Headers({ 'Content-Type': 'application/json', 'Language': this.languageCulture, 'SB-Token': localStorage.getItem('AuthToken'), 'PL-ID': userId });
  //   // const options = new RequestOptions({ headers });
  //   return this.http.get<IPlayedTicketTO[]>(url, { headers: this.httpHeaders }).pipe(
  //     map(response => response as IPlayedTicketTO[]),
  //     catchError(err => {
  //       observableThrowError(this.handleError(err));
  //       return [];
  //     })
  //   );
  // }

  getTicketsForMobile(token: string, limit: number, offset: number, dateFrom: Date, dateTo: Date, filter: string): Observable<IPlayedTicketWithGroupsTO[]> {
    const params = new HttpParams()
      .set('token', token.toString())
      .set('limit', limit.toString())
      .set('offset', offset.toString())
      .set('startDate', dateFrom.toISOString().replace('Z', ''))
      .set('endDate', dateTo.toISOString().replace('Z', ''))
      .set('filter', filter ? filter.toString() : filter);

    // if (environment.localDeploy) {
    //   return of(ticketsMobile);
    // }
    const url: string = this.baseUrlAndroid + 'tickets';
    return this.http.get<IPlayedTicketWithGroupsTO[]>(url, { headers: this.httpHeaders, params }).pipe(
      map(response => response as IPlayedTicketWithGroupsTO[]),
      catchError(err => {
        observableThrowError(this.handleError(err));
        return [];
      })
    );
  }

  getTicketsForMobileAffiliate(affiliateId: number, limit: number, offset: number, dateFrom: Date, dateTo: Date, filter: string): Observable<IPlayedTicketWithGroupsTO[]> {
    const params = new HttpParams();
    const body = JSON.stringify({
      affiliateId,
      limit,
      offset,
      startDate: dateFrom.toISOString().replace('Z', ''),
      endDate: dateTo.toISOString().replace('Z', ''),
      filter
    });
    const url: string = this.baseUrlWebClientAffiliate + 'tickets';
    return this.http.post<IPlayedTicketWithGroupsTO[]>(url, body, { headers: this.httpHeaders, params }).pipe(
      map(response => response as IPlayedTicketWithGroupsTO[]),
      catchError(err => {
        observableThrowError(this.handleError(err));
        return [];
      })
    );
  }

  getTicketById(ticketId: number): Observable<IPlayedTicketWithGroupsTO> {
    const url: string = this.baseUrlWebClientController + 'ticket/' + ticketId;
    return this.http.get(url, { headers: this.httpHeaders }).pipe(
      map(response => {
        if (response == null && environment.localDeploy) {
          return ticketMoibile;
        } else {
          return response as IPlayedTicketWithGroupsTO;
        }
      }),
      catchError(err => {
        observableThrowError(this.handleError(err));
        return [];
      })
    );
  }

  getOutcomesWithPlayableStatuses(updateTicketRequest: IUpdateTicketRequestObjTO[]): Observable<IBetOutcomeWithPlayableStatusTO[]> {
    const params = new HttpParams();
    const body = JSON.stringify(updateTicketRequest);
    const url: string = this.offerController + 'GetBetOutcomeWithPlayableStatusAsync';
    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as IBetOutcomeWithPlayableStatusTO[]),
      publishReplay(1),
      refCount(),
      catchError((err) => [[]]),
    );
  }

  // dont call from component for later
  placeBet(request: ITicketValidationRequestTO, isTicketManagerTicket: boolean): Observable<ITicketValidationResultTO> {
    if (isTicketManagerTicket){
      return this.placeBetTM(request);
    }

    if (this.storage.affiliate) {
      return this.placeBetTicketManagerWebTm(request);
    }
    const params = new HttpParams();
    const body = JSON.stringify(request);
    const url: string = this.baseUrlWebClientController + 'validateNew';

    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as IBetOutcomeWithPlayableStatusTO[]),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        observableThrowError(this.handleError(err, true, true));
        return [];
      }),
    );
  }

  placeBetTicketManagerWebTm(request: ITicketValidationRequestTO): Observable<ITicketValidationResultTO> {
    const params = new HttpParams();
    const body = JSON.stringify(request);
    const url: string = this.baseUrlWebClientAffiliate + 'validateNew';

    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as IBetOutcomeWithPlayableStatusTO[]),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        observableThrowError(this.handleError(err, true, true));
        return [];
      }),
    );
  }

  placeBetTM(request: ITicketValidationRequestTO): Observable<ITicketValidationResultTO> {
    const params = new HttpParams();
    const body = JSON.stringify(request);
    const url: string = this.baseUrlTicketManager + 'validate';

    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as IBetOutcomeWithPlayableStatusTO[]),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        observableThrowError(this.handleError(err));
        return [];
      }),
    );
  }



  // dont call from component for later
  placeFastBet(request: ITicketValidationRequestTO): Observable<ITicketValidationResultTO> {
    const params = new HttpParams();
    const body = JSON.stringify(request);
    const url: string = this.baseUrlWebClientController + 'fastTicket';

    if (environment.isAffiliateSite) {
      return this.placeFastBetWebTm(request);
    }

    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as IBetOutcomeWithPlayableStatusTO[]),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        observableThrowError(this.handleError(err, true, true));
        return [];
      }),
    );
  }

  placeFastBetWebTm(request: ITicketValidationRequestTO): Observable<ITicketValidationResultTO> {
    const params = new HttpParams();
    const body = JSON.stringify(request);
    const url: string = this.baseUrlWebClientAffiliate + 'fastTicket';

    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as IBetOutcomeWithPlayableStatusTO[]),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        observableThrowError(this.handleError(err, true, true));
        return [];
      }),
    );
  }

  cancelTicket(confirmRequest: ITicketConfirmationRequestTO): Observable<void> {
    const params = new HttpParams();
    const body = JSON.stringify(confirmRequest);
    const url: string = this.baseUrlWebClientController + 'cancelValidationTicket';

    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      publishReplay(1),
      refCount(),
      catchError((err) => {
        observableThrowError(this.handleError(err, true, true));
        return [];
      }),
    );
  }

  checkTicket(confirmRequest: ITicketConfirmationRequestTO): Observable<ITicketValidationResultTO> {
    const params = new HttpParams();
    const body = JSON.stringify(confirmRequest);
    const url: string = this.baseUrlWebClientController + 'checkValidationTicket';

    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as ITicketValidationResultTO),
      publishReplay(1),
      refCount()
    );
  }

  getStatusOfAuthorizationTicket(confirmRequest: ITicketConfirmationRequestTO): Observable<ITicketValidationResultTO> {
    if (this.storage.affiliate) {
      return this.getStatusOfAuthorizationWebTm(confirmRequest);
    }
    const params = new HttpParams();
    const body = JSON.stringify(confirmRequest);
    const url: string = this.baseUrlWebClientController + 'getStatusOfAuthorizationTicket';

    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as ITicketValidationResultTO),
      publishReplay(1),
      refCount()
    );
  }

  getStatusOfAuthorizationWebTm(confirmRequest: ITicketConfirmationRequestTO): Observable<ITicketValidationResultTO> {
    const params = new HttpParams();
    const body = JSON.stringify(confirmRequest);
    const url: string = this.baseUrlWebClientAffiliate + 'getStatusOfAuthorizationTicket';

    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as ITicketValidationResultTO),
      publishReplay(1),
      refCount()
    );
  }

  searchPlayerTicket(ticketNumber: string, code: string): Observable<IPlayedTicketWithGroupsTO> {
    const params = new HttpParams();
    const url: string = this.baseUrlWebClientController + 'searchPlayedTicketWithBranchCheck/' + ticketNumber + '/' + code;

    return this.http.get(url, { headers: this.httpHeaders, params }).pipe(
      publishReplay(1),
      refCount(),
      catchError((err) => {
        if (err.status === 404) {
          return of(null as any);
        } else {
          observableThrowError(this.handleError(err));
        }
      }),
    );
  }

  getCasheoutValue(generatedTicketId: string): Observable<ICashOutValueResponseTO> {
    let url: string;
    if (this.storage.affiliate) {
      url = this.baseUrlWebClientAffiliate + 'getCashOutValue?generatedTicketId=' + generatedTicketId;
    } else {
      url = this.baseUrlWebClientController + 'getCashOutValue?generatedTicketId=' + generatedTicketId;
    }
    const params = new HttpParams();
    return this.http.get(url, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as ICashOutValueResponseTO),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        // observableThrowError(this.handleError(err, false));
        return of({
          payout: 0,
          success: false,
          message: ''
        });
        return [];
      })
    );
  }

  sellBet(sellBetRequest: ISellBetRequest): Observable<ISellBetResponseTmTO | ISellBetResponseTO> {
    if (this.storage.affiliate) {
      const sellBetRequestTm: ISellBetRequestTm = {
        refundValue: sellBetRequest.refundValue,
        externalTicketId: sellBetRequest.generatedTicketId,
        pinCode: sellBetRequest.pinCode
      };
      return this.sellBetWebTm(sellBetRequestTm);
    }
    const params = new HttpParams();
    const body = JSON.stringify(sellBetRequest);
    const url: string = this.baseUrlWebClientController + 'cashOutTicket';
    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as ISellBetResponseTO),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        observableThrowError(this.handleError(err));
        return [];
      }),
    );
  }

  sellBetWebTm(sellBetRequestTm: ISellBetRequestTm): Observable<ISellBetResponseTmTO> {
    const params = new HttpParams();
    const body = JSON.stringify(sellBetRequestTm);
    const url: string = this.tcketManagerBaseUrl + 'ticket/cashOutTicket';
    return this.http.post<any>(url, body, { headers: this.httpHeaders, params })
    .pipe(
      map((response) => response as ISellBetResponseTmTO),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        observableThrowError(this.handleError(err));
        return [];
      })
    );
  }

  getFastTicket(ticketId: string): Observable<IExpressTicketTO> {
    // const url: string = this.baseUrlTerminal + 'fastTicket/' + ticketId;
    const url: string =  this.baseUrlWebClientController + 'fastTicket/' + ticketId;
    const params = new HttpParams();
    return this.http.get(url, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as IExpressTicketTO),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        observableThrowError(this.handleError(err, false));
        return [];
      })
    );
  }
}
